<template>
	<div>
		<version-viewer />
		<div class="wrapper-profile">
			<div class="wrapper-profile-image">
				<img src="@/assets/images/temp-profile-image.jpg" alt />
			</div>

			<div class="user-name">{{ username }}님</div>
			<button class="btn-edit-profile" @click="editProfile">프로필</button>
			<button class="btn-logout" @click="logout">로그아웃</button>
		</div>
	</div>
</template>

<script>
import VersionViewer from "../VersionViewer";

export default {
	name: "SidebarProfile",
	components: {
		VersionViewer
	},
	computed: {
		username() {
			return this.$store.getters.user.name;
		}
	},
	methods: {
		editProfile() {
			this.$router.push("/profile").catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			});
		},

		async logout() {
			const result = await this.$store.dispatch("logout");
			this.$toast(result.message);
			this.$router.replace("/").catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.wrapper-profile {
	padding: 48px 24px;

	.wrapper-profile-image {
		width: 100px;
		height: 100px;
		margin: 0 auto;
		border-radius: 100px;
		overflow: hidden;

		img {
			width: 100%;
		}
	}

	.user-name {
		color: #ffffff;
		margin: 16px 0;
	}

	button {
		border: none;
		color: rgba(255, 255, 255, 0.5);
		border-radius: 4px;
		background-color: transparent;
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/sidebar/profile/SidebarProfile.vue